"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cubeDocs = void 0;
var cubeDocs = exports.cubeDocs = {
  name: 'cube',
  category: 'Arithmetic',
  syntax: ['cube(x)'],
  description: 'Compute the cube of a value. The cube of x is x * x * x.',
  examples: ['cube(2)', '2^3', '2 * 2 * 2'],
  seealso: ['multiply', 'square', 'pow']
};